import object from '@mailobj-browser/front/js/utils/object.js'
import * as lightbox from './lightboxes/styles.js'

export const block = 'ea_utilities'

export const elements = object(null, {
  any: `${block}__any`,
  aside_alerts: `${block}__aside_alerts`,
  aside_confirms: `${block}__aside_confirms`,
  aside_lightboxes: `${block}__aside_lightboxes`,
  collapse: `${block}__collapse`,
  display: `${block}__display`,
  dropdown_icon: `${block}__dropdown_icon`,
  ellipsis: `${block}__ellipsis`,
  icon: `${block}__icon`,
  icon_option: `${block}__icon_option`,
  is_hidden_sm: `${block}__is_hidden_sm`,
  is_sr_only: `${block}__is_sr_only`,
  margin_right: `${block}__margin_right`,
  modal: `${block}__modal`,
  modal_footer: `${block}__modal_footer`,
  modal_header: `${block}__modal_header`,
  modal_main: `${block}__modal_main`,
  overflow: `${block}__overflow`,
  placeholder: `${block}__placeholder`,
  position: `${block}__position`,
  visibility: `${block}__visibility`
})

export const modifiers = object(null, {
  ...lightbox.modifiers,
  any: object(null, {
    fetching: `${elements.any}-fetching`
  }),
  display: object(null, {
    block: `${elements.display}-block`,
    flex: `${elements.display}-flex`,
    none: `${elements.display}-none`
  }),
  icon: object(null, {
    selected: `${elements.icon}-selected`
  }),
  margin_right: object(null, {
    zero: `${elements.margin_right}-0`
  }),
  overflow: object(null, {
    hidden: `${elements.overflow}-hidden`,
    hidden_sm: `${elements.overflow}-hidden_sm`,
    hidden_until_sm: `${elements.overflow}-hidden_until_sm`
  }),
  position: object(null, {
    fixed: `${elements.position}-fixed`
  }),
  visibility: object(null, {
    hidden: `${elements.visibility}-hidden`,
    visible: `${elements.visibility}-visible`
  }),
})
